/* -------------------------------------- accordion expand/collapse */
$(function(){
	if(window.location.hash){
		var $target = $(window.location.hash);
		if ($target.length) {
			setTimeout( function(){ $('html,body').stop().animate({ 'scrollTop': $target.offset().top }, 1000 ); } , 1000 );
			Accordion.Open($target);
		}
	}
	
		// create nav elements
		$('.accordion div h4').prepend(' <a class="toggle_btn">Toggle</a>');

		// all expand / collapse
		$('.accordion div h4').css({ cursor: 'pointer' });
		$('.accordion div h4').click(function(e){
			e.preventDefault();

			//tracking
			if( $(this).attr("data-track-event") ){
				parseData = $(this).attr("data-track-event").split(',');
				$(this).attr("data-track-event", parseData[0] +","+ ( $(this).closest('div').hasClass('show')?'hide':'show' ) +","+ parseData[2] );
				/*HERSHEY.tracker.trackCustom( $(this) );*/
			}

			$(this).closest('div')
				.toggleClass('show')
				.children('div').slideToggle();
		});
/*
		if(window.location.hash) {
			if($('.accordion h4'+window.location.hash).length>0){
				$(".accordion .show").removeClass("show").slideToggle(0);
				$('.accordion h4'+window.location.hash).trigger('click');
			}
		}
*/

		// single expand / collapse
		$('.accordion a.expandcollapse_icon').click(function(e){
			e.preventDefault();
			$('.accordion div').toggleClass('show');
			$('.accordion div div').slideToggle();
		});
		
		//default open 'show' divs
		$('.accordion .show div').slideDown();

	$('.zebraTable>div:nth-child(odd)').addClass('odd');
	$('.zebraTable>div:nth-child(even)').addClass('even');


    Accordion.Init();
});


/*
 * new accordion after ADA remediation
 */
var Accordion = {
    
    Init: function() {
        
        // Support both <a> and <button> elements for accordion triggers
        $('body').on('click', '.accordion dt a[role=button], .accordion dt button', function(){
            if($(this).attr('aria-expanded') == 'true') {
                Accordion.Close(this);
            }
            else {
                if($(this).parents('.accordion').hasClass('solo-accordion')) {
                    // Close any open accordions

                }
                Accordion.Open(this);
            }
            return false;
        });
    },
    
    Open: function(heading) {
        var headingID = $(heading).prop('id');
        var sectionID = headingID.replace('item', 'details');
        var section = $('#'+sectionID);
        
        section.slideDown(400).addClass('open');
        
        $(heading).attr('aria-expanded', 'true');
        $(heading).find('.toggle-expand').removeClass('toggle-expand').addClass('toggle-collapse');
    },
    
    Close: function(heading) {
        var headingID = $(heading).prop('id');
        var sectionID = headingID.replace('item', 'details');
        var section = $('#'+sectionID);
        
        section.slideUp(400).removeClass('open');
        
        $(heading).attr('aria-expanded', 'false');
        $(heading).find('.toggle-collapse').removeClass('toggle-collapse').addClass('toggle-expand');
    }
};